import React from 'react';
import PropTypes from 'prop-types';
import { ActionCreators } from '../redux/action-creators';
import { sanitizeDownload } from '../utils/sanitize-download';
import Icon from '@mapbox/mr-ui/icon';
import { saveAs } from 'file-saver';
import { RenameInput } from './shared/rename-input';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import { Feature } from './feature';
import { Overview } from './overview';
import stringify from 'json-stringify-pretty-compact';

const SortableList = sortableContainer(
  ({ children }) => {
    return <div>{children}</div>;
  },
  { withRef: true }
);

const SortableItem = sortableElement(
  ({ feature, activeFeature, mapResult, parentContainer }) => {
    const props = { feature, mapResult };
    if (
      activeFeature &&
      activeFeature.properties.__id === feature.properties.__id
    ) {
      props.active = true;
      props.parentContainer = parentContainer;
    }
    return <Feature {...props} />;
  }
);

class Sidebar extends React.PureComponent {
  containerRef = React.createRef();

  download = () => {
    const { geojson } = this.props;
    const blob = new Blob([stringify(sanitizeDownload(geojson))], {
      type: 'text/plain;charset=utf-8'
    });

    saveAs(blob, `${geojson.name}.json`);
  };

  back() {
    ActionCreators.home(true);
  }

  render() {
    const { activeFeature, geojson, mapResult } = this.props;
    let overview;

    let features = (
      <div className="px12 py12">
        <div className="flex-parent flex-parent--center-cross flex-parent--center-main h120 round w-full border border--gray-light border--dash">
          <div className="flex-child align-center txt-bold txt-m txt-fancy color-gray-light">
            No places. Choose "Add place"
          </div>
        </div>
      </div>
    );

    if (geojson.features.length) {
      features = (
        <SortableList
          onSortEnd={ActionCreators.updateFeatureIndex}
          useDragHandle={true}
        >
          {geojson.features.map((feature, index) => {
            const { __id: id } = feature.properties;
            return (
              <SortableItem
                key={id}
                index={index}
                feature={feature}
                activeFeature={activeFeature}
                mapResult={mapResult}
                parentContainer={this.containerRef.current}
              />
            );
          })}
        </SortableList>
      );

      overview = (
        <div className="h180 relative py24 round-full w180 scroll-hidden mx-auto mt24 mb12">
          <Overview activeFeature={activeFeature} geojson={geojson} />
        </div>
      );
    }

    return (
      <div className="flex-parent--column h-full">
        <div className="flex-child flex-parent flex-parent--align-cross py12 px12 border-b border--gray-light">
          <div className="flex-child">
            <button
              test="back"
              onClick={this.back}
              className="txt-s txt-bold link link--gray"
            >
              <Icon name="chevron-left" inline={true} />
              Back
            </button>
          </div>
          <div className="flex-child flex-child--grow align-r">
            <button
              test="download"
              onClick={this.download}
              className="txt-s btn bg-blue-faint link transition"
            >
              <Icon name="harddrive" inline={true} />
              <span className="ml3">Download</span>
            </button>
          </div>
        </div>
        {overview}
        <div className="flex-child py12 px12 border-b border--gray-light">
          <RenameInput
            value={geojson.name}
            onChange={ActionCreators.setName}
            classList={'txt-h4 txt-fancy'}
          />
        </div>
        <div
          ref={this.containerRef}
          className="flex-child flex-child--grow scroll-auto scroll-styled h-full pb360"
        >
          {features}
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  mapResult: PropTypes.object,
  activeFeature: PropTypes.object,
  geojson: PropTypes.object
};

export { Sidebar };
